import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

function CmsRotator() {
	$('.js-cms-slider').each(function(index) {
		let $this = $(this);
		$this.addClass('cms-slider-' + index);
		let $parent = $(this).closest('.cms-slider__parent');
		$parent.addClass(`cms-slider__parent-${index}`);
		$parent.find('.cms-slider__navigation').addClass(`cms-slider__navigation-${index}`);
		$parent.find('.cms-slider__counter').addClass(`cms-slider__counter-${index}`);
		let cmsSliderList = [];
		let $counterContainer = $(`.cms-slider__counter-${index}`);

		let cmsSlider = new Swiper('.cms-slider-' + index, {
			slidesPerView: 1,
			speed: 400,
			spaceBetween: 0,
			centeredSlides: true,
			loop: false,
			simulateTouch: true,

			navigation:  {
				nextEl: `.cms-slider__navigation-${index} .swiper-button-next`,
				prevEl: `.cms-slider__navigation-${index} .swiper-button-prev`
			},

			on: {
				init: function (swiper) {
					$counterContainer.text(`${swiper.activeIndex + 1}/${swiper.slides.length}`)
				},
				slideChange: function (swiper) {
					$counterContainer.text(`${swiper.activeIndex + 1}/${swiper.slides.length}`);
				}
			}
		});

		cmsSliderList.push(cmsSlider);
		cmsSlider.init();
	});
}

export function init() {
	let cSlider = $('.js-cms-slider');

	if(!cSlider.length) {
		return;
	}

	CmsRotator();
}
